import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Country } from '../webApi/DataModels'
import { map, filter } from 'lodash'

class CountryState {
  public countries: Country[] = []
  public countryOptions: any[] = []
}

const mutations = <MutationTree<CountryState>>{
  setCountries (state: CountryState, countries: Country[]) {
    state.countries = countries
    state.countryOptions = countries.map((country: Country) => {
      return {
        value: country.Country_ID,
        label: country.Country_Name,
        selected: false
      }
    })
    window.sessionStorage.setItem('Country_List', JSON.stringify(state.countries))
  },
  reset (state:CountryState) {
    state.countries = []
    state.countryOptions = []
  }
}

const actions = <ActionTree<CountryState, any>>{
  reset (store: ActionContext<CountryState, any>):void {
    store.commit('reset')
  },
  loadCountries (store: ActionContext<CountryState, any>):Promise<any> {
    if (window.sessionStorage.getItem('Country_List') != null) {
      // the list has already been stored in session
      store.commit('setCountries', JSON.parse(window.sessionStorage.getItem('Country_List')))
      return Promise.resolve('success')
    } else {
      // the list has not been stored in session yet, load from server
      return webApi.country.get_Countries().then(
        (response) => {
          // Store the response
          store.commit('setCountries', response.data)
          return Promise.resolve('success')
        }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading countries: ' + response.ExceptionMessage)
        return Promise.reject(response)
      })
    }
  }
}

const getters = <GetterTree<CountryState, any>>{
  countries: (state) => {
    return state.countries
  },
  countryOptions: (state) => {
    return state.countryOptions
  },
  countryNames (state:CountryState):any {
    return (countryIDs:number[]) => {
      return map(filter(state.countries, country => (countryIDs.indexOf(country.Country_ID) > -1)), 'Country_Name')
    }
  }
}
export default ({
  namespaced: true,
  state: new CountryState(),
  mutations,
  actions,
  getters
})
